import type { KameleoonFeatureFlagKey } from './lib/kameleoon-variables'

export type FeatureFlagKey = KameleoonFeatureFlagKey

export * from './lib/kameleoon-variables'
export * from './lib/flight-feature-flags'
